import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { NgaModule } from '../../theme/nga.module';

//import { LoginCopy } from './login.componentcopy';
import { Login } from './login.component';
import { routing } from './login.routing';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SearchUserComponent } from './searchUser.component';
import { SendEmailComponent } from './sendEmail.component';
import { enterSecurityComp } from './enterSecurityCode.component';
import { NewPasswordComp } from './newPassword.component';
import { NgaModule } from 'src/app/theme/nga.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgaModule,
    routing,
    ModalModule.forRoot(),
  ],
  declarations: [
    Login,
    //LoginCopy,
    SearchUserComponent,
    SendEmailComponent,
    enterSecurityComp,
    NewPasswordComp,
  ],
  exports: [Login, SendEmailComponent],
})
export class LoginModule {}
